import { ConfigProvider, Form, Tabs } from 'antd'
import React, { useMemo } from 'react'
import enUS from "antd/locale/en_US";
import classNames from 'classnames';

import classes from './PVTSetting.module.scss'
import DensityTable from './DensityTable';
import RockTable from './RockTable';
import WaterTable from './WaterTable';
import GasTable from './GasTable';
import OilTable from './OilTable';

const PVTSetting = () => {
  const form = Form.useFormInstance()
  
  // Watch values from General Settings
  const fluidType = Form.useWatch(['GENERAL', 'fluid'], form)
  const simulationUnit = Form.useWatch(['GENERAL', 'unit'], form)
  const reservoirType = Form.useWatch(['GENERAL', 'reservoir'], form)

  const tabs = useMemo(
    /**
     * @returns {import('antd').TabsProps['items']}
     */
    () => {
      const baseTabs = [
        {
          key: 'Density',
          label: 'Density',
          children: <DensityTable />
        },
        {
          key: 'Rock',
          label: 'Rock',
          children: <RockTable />
        },
        {
          key: 'Water',
          label: 'Water',
          children: <WaterTable />
        }
      ]

      // Add Gas tab for all fluid types
      baseTabs.push({
        key: 'Gas',
        label: 'Gas',
        children: (
          <Form.List name={["PVT", "gas"]}>
            {(fields, operation) => (
              <GasTable 
                fields={fields} 
                operation={operation}
                simulationUnit={simulationUnit} 
              />
            )}
          </Form.List>
        )
      })

      // Add Oil tab only for BLACK_OIL and CONDENSATE fluid types
      if (fluidType === 'BLACK_OIL' || fluidType === 'CONDENSATE') {
        baseTabs.push({
          key: 'Oil',
          label: 'Oil',
          children: (
            <Form.List name={["PVT", "oil"]}>
              {(fields, operation) => (
                <OilTable 
                  fields={fields} 
                  operation={operation}
                  simulationUnit={simulationUnit}
                  fluidType={fluidType}
                />
              )}
            </Form.List>
          )
        })
      }

      return baseTabs
    }, [fluidType, simulationUnit]) // Add dependencies for memoization

  return (
    <ConfigProvider
      locale={enUS}
      componentSize="middle"
      theme={{
        token: {},
        components: {},
      }}
    >
      <Tabs 
        type="card" 
        items={tabs} 
        className={classNames(classes.tabs, classes.parentTabs)} 
        destroyInactiveTabPane={false} 
      />
    </ConfigProvider>
  )
}

export default PVTSetting